<template>
  <div id="login">
    <div class="left">
      <img src="../../assets/icon/login.png" alt />
    </div>
    <div class="right">
      <div class="right-content">
        <img src="../../assets/icon/qrLogo.png" alt />
        <div class="title">钱如潮收银系统</div>
        <div class="main">
          <h1>欢迎登录</h1>
          <div class="phone">
            <!-- <span class="district">中国+86</span>
            -->
            <span>
              <el-select v-model="value" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </span>
            <input type="text" v-model="phoneNumber" placeholder="请输入手机号" />
          </div>

          <div class="password">
            <input ref="password" v-model="passWord" id="password" type="password" placeholder="请输入密码" />
            <img v-if="isok" style="width: 19px;height: 11px" @click="isshow" :src="passwordImg" alt />
            <img v-if="!isok" style="width: 19px;height: 11px" @click="isshow" :src="passwordImg2" alt />
          </div>
          <div class="remember">
            <el-checkbox v-model="isRemember">记住密码</el-checkbox>
          </div>

          <el-button type="primary" @click="login">登录并创建店铺</el-button>

          <div class="main-bottom">
            <el-checkbox v-model="check">
              <span class="text">已阅读同意</span>
              <a href="http://www.163.gg/aboutus.html">《用户使用协议》</a>
              <span class="toto">
                <router-link to="/forgetThePassword">忘记密码</router-link>
                <span style="color: rgb(244,244, 244);margin: 0 5px;">|</span>
                <router-link to="/register">免费注册</router-link>
              </span>
            </el-checkbox>
          </div>
        </div>
      </div>
      <div class="Copyright">
        <p>Copyright©2016-2020 <span style="cursor: pointer;" @click="goUrl">浙ICP备16020428号-17</span> 温州专帮信息科技有限公司 版权所有</p>
      </div>
    </div>
  </div>
</template>
<script>
import crypto from "crypto";
export default {
  name: "login",

  data() {
    return {
      successButton: true, //确认按钮
      check: true, //阅读同意
      phoneNumber: "", //输入手机号
      passWord: "", //重复密码
      passwordImg: require("../../assets/icon/bxsmm.png"),
      passwordImg2: require("../../assets/icon/xsmm.png"),
      isok: true, //控制密码的显隐
      isRemember: false, //控制是否记住密码
      //国家首号下拉列表
      options: [
        {
          value: "选项1",
          label: "中国+86"
        },
        {
          value: "选项2",
          label: "美国+32"
        },
        {
          value: "选项3",
          label: "英国+43"
        },
        {
          value: "选项4",
          label: "日本+69"
        },
        {
          value: "选项5",
          label: "新加坡+52"
        }
      ],
      value: "中国+86"
    };
  },

  watch: {
    // phoneNumber: function() {
    //   this.watchLogin();
    // },
    // passWord: function() {
    //   this.watchLogin();
    // },
    // check: function() {
    //   this.watchLogin();
    // }
  },

  created() {
    let account = this.getCookie("account");
    let password = this.getCookie("password");
    if (account && password) {
      this.phoneNumber = account;
      this.passWord = password;
      this.isRemember = true;
    }
    this.watchLogin(); //表单验证
    // console.log(account, password, "缓存区提取");
  },

  methods: {
    isshow: function () {
      this.isok = !this.isok;
      if (this.isok) {
        this.$refs.password.type = "password";
      } else {
        this.$refs.password.type = "text";
      }
    },

    //登录
    login() {
      if (this.check) {
        var that = this;
        // md5加密 32位大写
        var passWord = this.passWord;
        var md5 = crypto.createHash("md5");
        md5.update(passWord);
        passWord = md5.digest("hex");
        passWord = passWord.toUpperCase();
        console.log(this.phoneNumber, passWord, "登录");
        var arr = ['18295669511']
        if (arr.includes(this.phoneNumber)) {
          alert("付费功能，限制使用！");
          return
        }
        this.request
          .post("qrcapi/Login_login", {
            userName: this.phoneNumber,
            passWord: passWord,
            device: "PC",
            usePl: 0
          })
          .then(function (res) {
            // that.reqImg(); //刷新验证码
            console.log(res);
            if (res.code == 1) {
              that.$message({
                message: res.msg,
                type: "success"
              });

              console.log(JSON.stringify(res.data), "登录成功");
              that.setCookie("userList", JSON.stringify(res.data)); //用户信息存储
              // localStorage.setItem("userList1", JSON.stringify(res.data))
              //判断是否存在店铺
              that.request
                .get("qrcapi/Shop_isExistShop", {
                  userId: res.data.id,
                  sessionId: res.data.sessionId
                })
                .then(function (e) {
                  if (e.code == 1) {
                    that.request
                      .get("qrcapi/Shop_shopInfo", {
                        userId: res.data.id,
                        sessionId: res.data.sessionId
                      })
                      .then(function (res) {
                        console.log(res, "shopInformation");
                        that.setCookie(
                          "shopInformation",
                          JSON.stringify(res.data)
                        );
                        that.$store.state.shopInformation = res.data;
                        if (res.code == 1) {

                          that.$router.push("/home");

                          //  that.$message.error("未创建店铺");

                        }
                      })
                      .catch(function (error) {
                        console.log('error', error);
                      });
                  } else {
                    that.request
                      .get("qrcapi/Shop_shopInfo", {
                        userId: res.data.id,
                        sessionId: res.data.sessionId
                      })
                      .then(function (res) {
                        console.log(res, "店铺信息");
                        that.setCookie(
                          "shopInformation",
                          JSON.stringify(res.data)
                        );
                        that.$store.state.shopInformation = res.data;
                        if (res.code == 1) {
                          //  that.$message.error("未创建店铺");

                        }
                      })
                      .catch(function (error) {
                        alert("网络错误，不能访问1");
                        console.log(error);
                      });
                    that.$router.push("/creatStore");
                  }
                })
                .catch(function (error) {
                  alert("网络错误，不能访问2");
                  console.log(error);
                });

              that.setUserInfo(); //存储登录信息
            } else {
              that.$message.error(res.msg);
            }
          })
          .catch(function (error) {
            alert("网络错误，不能访问3");
            console.log(error);
          });
      } else {
        this.$message.error("请先同意用户使用手册");
      }
    },
    goUrl() {
      window.location.href = "https://beian.miit.gov.cn"
    }
  }
};
</script>

<style scoped>
.title {
  color: #a9a9a9;
  font-size: 25px;
  margin: 30px 0;
}

.Copyright {
  position: absolute;
  bottom: 20px;
  color: #a9a9a9;
  /* left: 30%; */
}
</style>


// WEBPACK FOOTER //
// src/components/page/login.vue